import { BaseResource } from 'utils/ApiUtils';

export default class Resource extends BaseResource {
    constructor(args) {
      super(args, Resource.attributes);
    };
  
    static columns = [
      { title: "RassignmentId", field: "RassignmentId", type: "string", hidden: true },
      { title: "Resource Name", field: "Name_SystemUser", type: "string" },
      { title: "SystemUserId", field: "SystemUserId_SystemUser", type: "string", hidden: true},
      { title: "Manager", "field": "Name_ManagerAssignment", type: "string"},
      { title: "Inspector Number", field: "InspectorNumber_SystemUser", type: "string"},
      { title: "Required QC", field: "QcReqYn", type: "boolean" },
      { title: "Active?", field: "IsActive", type: 'boolean' },
      { title: "Email", field: "Email_SystemUser", type: "string", hidden: true },
    ]
  
    static IDR_columns = [
      { title: "Resource Name", field: "Name_SystemUser" },
      { title: "Email Address", field: "QcReqYn" },
      { title: "Select", field: "QcReqYn" }
    ]
  
    static expand = [
      { 'SystemUser': { select: ['Name', 'InspectorNumber', 'SystemUserId','Email'] } },
      { 'ManagerAssignment': { select: ['Name'] } }
    ]
  
    static attributes = Resource.columns.map(r => r.field);
    static IDR_attributes = Resource.columns.map(r => r.field);
  };